import * as React from 'react';
import * as footer from './footerMedium.module.scss';
export const FooterMedium = () => {
  return (
    <footer className={footer.footerMedium}>
      <div className="container">
        <div className={`row ${footer.footerMedium__row} no-gutter`}>
          <div className="col-12 col-md-6 col-lg-3">
            <a href="/">
              <img src="https://fs.advance.ru/landing-pages/icons/advance-logo/advance_new_logo.svg" alt={'Advance'} />
            </a>
            <div className={footer.footer__social}>
              <ul>
                <li>
                  <a href="https://vk.com/advanceclub">
                    <img
                      src="https://fs.advance.ru/landing-pages/icons/social/vk_white.svg"
                      alt={'Advance вконтакте'}
                    />
                  </a>
                </li>
                <li>
                  <a href="https://ok.ru/advanceclub">
                    <img
                      src="https://fs.advance.ru/landing-pages/icons/social/ok_white.svg"
                      alt={'Advance в одноклассниках'}
                    />
                  </a>
                </li>
                <li>
                  <a href="https://www.youtube.com/user/advanceclub">
                    <img
                      src="https://fs.advance.ru/landing-pages/icons/social/utube_white.svg"
                      alt={'Advance на ютуб'}
                    />
                  </a>
                </li>
                <li>
                  <a href="https://t.me/advance_official">
                    <img
                      src="https://fs.advance.ru/landing-pages/icons/social/tg_white.svg"
                      alt={'Advance в телеграм'}
                    />
                  </a>
                </li>
              </ul>
            </div>
            <p className={footer.footerMedium__text}>advance (англ.) — продвигаться</p>
          </div>

          <div className="col-12 col-md-6 col-lg-3">
            <a href="tel:88007005342">8 (800) 700-53-42</a>
            <a href="tel:+78122092519">8 (812) 209-25-19</a>
            <a href="mailto:info@advance.ru" target="_self">
              info@advance.ru
            </a>
          </div>

          <div className="col-12 col-md-6 col-lg-3">
            <p>ООО «АДВАНС»</p>
            <p>ИНН 7842181720</p>
            <p>ОГРН 1207800072160</p>
            <p>Санкт-Петербург, ул. Таврическая, д. 2, лит. А, пом. 1Н</p>
          </div>

          <div className="col-12 col-md-6 col-lg-3">
            <div>
              <a href="/about/documents/soglashenie_ob_obrabotke_personalnyh_dannyh/">
                Соглашение об обработке
                <br />
                персональных данных
              </a>
              <a href="/about/documents/politika_konfidencialnosti/">Политика конфиденциальности</a>
              <a href="https://islod.obrnadzor.gov.ru/rlic/details/d862d996-835c-b9a5-ff8f-521ac3951a1e/">
                Государственная лицензия
              </a>
            </div>
            <div className={footer.footer__license}>
              <img src="https://fs.advance.ru/landing-pages/images/license.jpg" alt={'Государственная лицензия'} />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export const FooterMediumInner = () => {
  return (
    <footer className={footer.footerMedium}>
      <div className="container">
        <div className={`row ${footer.footerMedium__row} no-gutter`}>
          <div className="col-12 col-md-6 col-lg-3">
            <img src="https://fs.advance.ru/landing-pages/icons/advance-logo/advance_new_logo.svg" alt={'Advance'} />
            <div className={footer.footer__social}>
              <ul>
                <li>
                  <a href="https://vk.com/advanceclub">
                    <img
                      src="https://fs.advance.ru/landing-pages/icons/social/vk_white.svg"
                      alt={'Advance вконтакте'}
                    />
                  </a>
                </li>
                <li>
                  <a href="https://ok.ru/advanceclub">
                    <img
                      src="https://fs.advance.ru/landing-pages/icons/social/ok_white.svg"
                      alt={'Advance в одноклассниках'}
                    />
                  </a>
                </li>
                <li>
                  <a href="https://www.youtube.com/user/advanceclub">
                    <img
                      src="https://fs.advance.ru/landing-pages/icons/social/utube_white.svg"
                      alt={'Advance на ютуб'}
                    />
                  </a>
                </li>
                <li>
                  <a href="https://t.me/advance_official">
                    <img
                      src="https://fs.advance.ru/landing-pages/icons/social/tg_white.svg"
                      alt={'Advance в телеграм'}
                    />
                  </a>
                </li>
              </ul>
            </div>
            <p className={footer.footerMedium__text}>advance (англ.) — продвигаться</p>
          </div>

          <div className="col-12 col-md-6 col-lg-3">
            <a href="tel:88007005342">8 (800) 700-53-42</a>
            <a href="tel:+78122092519">8 (812) 209-25-19</a>
            <a href="mailto:info@advance.ru" target="_self">
              info@advance.ru
            </a>
          </div>

          <div className="col-12 col-md-6 col-lg-3">
            <p>ООО «АДВАНС»</p>
            <p>ИНН 7842181720</p>
            <p>ОГРН 1207800072160</p>
            <p>Санкт-Петербург, ул. Таврическая, д. 2, лит. А, пом. 1Н</p>
          </div>

          <div className="col-12 col-md-6 col-lg-3">
            <div>
              <a href="/about/documents/soglashenie_ob_obrabotke_personalnyh_dannyh_inner/">
                Соглашение об обработке
                <br />
                персональных данных
              </a>
              <a href="/about/documents/politika_konfidencialnosti_inner/">Политика конфиденциальности</a>
              <a href="https://islod.obrnadzor.gov.ru/rlic/details/d862d996-835c-b9a5-ff8f-521ac3951a1e/">
                Государственная лицензия
              </a>
            </div>
            <div className={footer.footer__license}>
              <img src="https://fs.advance.ru/landing-pages/images/license.jpg" alt={'Государственная лицензия'} />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
